{
  "es": {
    "task": {
      "actions": {
        "create": "Tarea",
        "update": "Editar tarea"
      },
      "attributes": {
        "assignments_count": "Asignaciones",
        "category": "Categoría",
        "created_at": "Creado",
        "description": "Descripción",
        "title": "Título",
        "units": "Unidades"
      },
      "categories": {
        "confirmation": "Confirmación",
        "upload": "Subida"
      },
      "labels": {
        "no_tasks": "Todavía no hay tareas para este proyecto.",
        "required": "Este campo es obligatorio",
        "units_required": "Selecciona al menos una unidad"
      },
      "toasts": {
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "update": "Tarea actualizada"
      }
    }
  }
}
